export default "__VITE_ASSET__DTvHqFfO__"